import { MinzeElement, Reactive, EventListeners } from "minze";
import { MODALS, config } from "../constants";
import MainModule from "../modules/main";
import { Routing } from "../modules/routing";
import { Locale } from "../modules/locale";

declare global {
  interface Window {
    TJ_MAIN_MODULE: MainModule;
    TJ_SEARCH_CONFIGS: {
      searchCoreConfigs: {
        [key: string]: {
          index: string;
          defaultQuery: string;
          defaultFacets: [];
        };
      };
    };
  }
}

interface AuthStatusEvent {
  isLoggedIn: boolean;
}

export interface TjWrapper {
  modalId: string;
}

export class TjWrapper extends MinzeElement {
  reactive: Reactive = [
    ["isLoggedIn", false],
    ["modalId", ""],
  ];
  lang = Locale.language;

  private getRoutes(): string {
    const lang: string = this.lang;

    let content = "<pre>";
    let enObj: any = config?.routing?.en;
    let frObj: any = config?.routing?.fr;
    if (lang === "fr") {
      content += Object.keys(frObj)
        .map((v: string) => {
          let link: string = Routing.JoinURLParts(Routing.HOST, frObj?.[v]);

          return `<a href="${link}">${link}</a>`;
        })
        .join("</br>");
    } else {
      content += Object.keys(enObj)
        .map((v: string) => {
          let link: string = Routing.JoinURLParts(Routing.HOST, enObj?.[v]);
          return `<a href="${link}">${link}</a>`;
        })
        .join("</br>");
    }
    content += "</pre>";
    return content;
  }

  html = () => `
    <div class="container-large">
      ${this.modalId === MODALS.SEARCH_CONTAINER ? `<tj-search-bar data-group-id="parents"></tj-search-bar>` : ""}
      ${
        this.modalId === MODALS.SEARCH_RESULTS
          ? `
        <tj-search-bar data-group-id="parents"></tj-search-bar>
        <tj-search-wrapper data-group-id="parents"></tj-search-wrapper>
      `
          : ""
      }
      ${this.modalId === MODALS.NEWSLETTER ? `
        <div class="newsletter-wrapper">
          <div class="newsletter-text-wrapper">test</div>
          <tj-newsletter></tj-newsletter>
        </div>` : ""}
      ${this.modalId === MODALS.CONTACT_FORM ? `<tj-contact-form></tj-contact-form>` : ""}
      ${this.modalId === MODALS.TRAINING_FORM ? `<tj-training-form></tj-training-form>` : ""}
      ${this.modalId === MODALS.SERVICES_FORM ? `<tj-services-form></tj-services-form>` : ""}
      ${this.modalId === MODALS.KIT_FORM ? `<tj-kit-form></tj-kit-form>` : ""}
      ${this.modalId === MODALS.POPUP_FORM ? `<tj-popup-form></tj-popup-form>` : ""}
      ${this.modalId === MODALS.CONTACT_POPUP_FORM ? `<tj-contact-popup-form></tj-contact-popup-form>` : ""}
      ${this.modalId === MODALS.TRAINING_POPUP_FORM ? `<tj-training-popup-form></tj-training-popup-form>` : ""}
      ${this.modalId === MODALS.SERVICES_POPUP_FORM ? `<tj-services-popup-form></tj-services-popup-form>` : ""}
      ${this.modalId === MODALS.PROMOTIONAL_MATERIAL_FORM ? `<tj-promotional-material-form></tj-promotional-material-form>` : ""}
      ${this.modalId === MODALS.PODCASTS ? `<tj-podcasts></tj-podcasts>` : ""}
      ${this.modalId === MODALS.COOKIES_POPUP ? `<tj-cookies-popup></tj-cookies-popup>` : ""}
      ${
        this.modalId === MODALS.NONE
          ? `
        <h1>Tel-Jeunes Webcomponent Development Page</h1><br/>
        <div style="overflow:hidden;">
          <div style="padding:128px 0px;max-width:1140px;margin:auto">
            <tj-forum-post-slider></tj-forum-post-slider>
          </div>
        </div>

        <h2>Forms V2</h2>
        <h3>tj-intro-workshop-form</h3>
        <tj-intro-workshop-form></tj-intro-workshop-form>
        <h3>tj-love-workshop-form</h3>
        <tj-love-workshop-form></tj-love-workshop-form>
        <h3>tj-mental-health-workshop-form</h3>
        <tj-mental-health-workshop-form></tj-mental-health-workshop-form>
        <h3>tj-sexuality-workshop-form</h3>
        <tj-sexuality-workshop-form></tj-sexuality-workshop-form>
        <div class="divider"></div>
        <h2>tj-cv-file-upload</h2>
        <tj-cv-file-upload data-job-title="Test Job Title"></tj-cv-file-upload>
        <div class="divider"></div>
        <h2>Auth Wrapper</h2>
        <tj-auth-wrapper>
          <span slot="auth">User is connected</span>
          <span slot="unauth">Please connect</span>
        </tj-auth-wrapper>
        <div class="divider"></div>
        <h2>Modal Routes</h2>
        <pre>${window.location.toString()}</pre><br/>
        ${this.getRoutes()}
        `
          : ""
      }
            
    </div>
  `;

  onStart(): void | Promise<void> {
    const lang = this.lang === "fr" ? "fr" : "en";

    let mainModule = window.TJ_MAIN_MODULE;
    if (!mainModule) {
      window.TJ_MAIN_MODULE = new MainModule(lang);
    }
  }

  onReady() {
    const mainModule = window.TJ_MAIN_MODULE;
    const modalId = mainModule.getModalIdFromRouting();

    this.modalId = modalId;

    this.rerender();
  }

  openLogin = () => {
    const mainModule = window.TJ_MAIN_MODULE;

    mainModule.showModal(MODALS.LOGIN_MODAL);
  };

  openSignup = () => {
    const mainModule = window.TJ_MAIN_MODULE;

    mainModule.showModal(MODALS.SIGNUP_MODAL);
  };

  openProfile = () => {
    const mainModule = window.TJ_MAIN_MODULE;

    mainModule.showModal(MODALS.PROFILE_MODAL);
  };

  openSearch = () => {
    const mainModule = window.TJ_MAIN_MODULE;

    mainModule.showModal(MODALS.SEARCH_CONTAINER);
  };

  handleAuthChanged = (event: Event) => {
    const detail = (event as CustomEvent<AuthStatusEvent>).detail;

    this.isLoggedIn = detail.isLoggedIn;
  };

  css = () => `
    :host {
      margin: 0!important;
      padding: 0!important;
      /* padding: 40px; */
    }
    .newsletter-wrapper {
      background-color: #133762;
      display: grid;
      grid-template-columns: 1fr 1fr
    }
    .gallery-image-test {
      width: 200px;
      aspect-ratio: 1;
      object-fit: cover;
    }
    .container-medium {
      max-width: 800px;
      margin: 0 auto;
    }
    .divider {
      margin-top: 2rem;
      margin-bottom: 2rem;
      border-bottom: 1px solid #000;
    }
    @media only screen and (min-width: 300px) and (max-width: 620px){
      :host {
        padding: 0 16px;
      }
    }

    .text {
      text-align: center;
      font-size: 1.25rem;
      font-weight: bold;
    }

    .count {
      text-align: center;
    }
  `;

  eventListeners: EventListeners = [
    ["#login", "click", this.openLogin],
    ["#profile", "click", this.openProfile],
    ["#search", "click", this.openSearch],
    ["#signup", "click", this.openSignup],
    [window, "tj:user_state_changed", this.handleAuthChanged],
  ];
}
